<script setup lang="ts">
import { Event, RevolugoVuePreferencesMenu } from '@revolugo/elements-vue3'

import type { Currency } from '@revolugo/common/constants'

const { eventBus } = useEventBus()

const router = useRouter()
const route = useRoute()

onMounted(() => {
  eventBus.value.$on(Event.CurrencyUpdated, (currency: Currency) => {
    // Update the URL query params with the new currency, preserving existing params
    router.replace({
      query: {
        ...route.query,
        currency,
      },
    })
  })
})
</script>

<template>
  <div
    class="w-full h-12 px-2 flex justify-between items-center sticky top-0 bg-white z-50 shadow-md"
  >
    <!-- https://github.com/nuxt/nuxt/issues/13494 -->
    <!-- problem with public/ for images -->
    <img
      alt="logo"
      src="../../public/images/logo.svg"
      class="h-7"
    />
    <div class="flex gap-1">
      <RevolugoVuePreferencesMenu
        :compact="false"
        direction="bottom"
      />
    </div>
  </div>
</template>
